import { useMutation } from '@tanstack/react-query';

import Axios from 'axios';

import { forceReloadContact } from '@hooks/API/Contact/UseContact';
import { forceReloadModels, forceReloadCustomers } from '@hooks/API/Contact/UseContactsList';

const editContactAlert = (params) => {
    const alertdata = { ...params };
    Axios.post('/contacts/setAlert', alertdata);
};

const deleteContactAlert = ({ ContactID }) => Axios.delete(`/contacts/removeAlert/${ContactID}`);

const useEditContactAlert = () => {
    return useMutation({
        mutationFn: editContactAlert,
        onSuccess: (data, variables) => {
            forceReloadContact(variables.ContactID);
            forceReloadCustomers();
            forceReloadModels();
        },
    });
};

const useDeleteContactAlert = () => {
    return useMutation({
        mutationFn: deleteContactAlert,
        onSuccess: (data, variables) => {
            forceReloadContact(variables.ContactID);
            forceReloadCustomers();
            forceReloadModels();
        },
    });
};

export { useEditContactAlert, useDeleteContactAlert };
